<template>
  <section>
    <h5 v-if="editReview" class="capitalize mt-8 text-lg font-bold">
      Edit Review
    </h5>
    <div class="flex items-center mt-2">
      <Avatar
        :src="baseUrlSrc(details && details.thumbnail_url)"
        classStr="h-8 w-8"
      />
      <span class="text-gray-900 capitalize ml-2"
        >{{ getUser() && getUser().name }}
      </span>
    </div>
    <form ref="reviewPost" @submit.prevent="handleUserReview">
      <div class="mt-2">
        <label class="block">
          <textarea
            class="form-textarea mt-1 block w-full px-1"
            rows="3"
            placeholder="Give your feedback to the trainer..."
            v-model="$v.body.$model"
            :classStr="{ 'border-red-500': $v.body.$error }"
          ></textarea>
          <div v-if="$v.body.$error">
            <small class="text-red-500" v-if="!$v.body.required">
              Reviews body is required
            </small>
          </div>
        </label>
      </div>
      <div class="mt-2 flex items-center justify-between">
        <div>
          <div class="flex">
            <div v-for="(d, i) in 5" :key="i" class="mr-1">
              <button
                type="button"
                @click="handleStarClick(d)"
                class="focus:outline-none"
              >
                <Star v-if="i < rating" classStr="text-yellow-medium w-6 h-6" />
                <StarOutlined v-else :classStr="'text-yellow-medium w-6 h-6'" />
              </button>
            </div>
          </div>
          <span v-if="$v.rating.$error">
            <small class="text-red-500" v-if="!$v.rating.required">
              Rating is required
            </small>
          </span>
        </div>
        <div>
          <button
            type="button"
            class="text-green-light cursor-pointer focus:outline-none hover:shadow-lg p-2"
            @click="hideReviewPost()"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="bg-green-light text-white px-4 py-1 ml-4 rounded focus:outline-none hover:shadow-lg"
          >
            Save
          </button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import { Star, StarOutlined } from "@/components/icons";
import { Avatar } from "@/components/t-components";
import { required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";

export default {
  name: "SessionReviewPost",
  components: {
    Avatar,
    Star,
    StarOutlined,
  },
  props: {
    data: {
      type: [Array, Object],
    },
    editReview: {
      type: Boolean,
      default: false,
    },
    review_id: {
      type: Number,
      default: 0,
    },
    callerComp: {
      type: String
    }
  },
  data() {
    return {
      title: "",
      body: "",
      rating: "",
      details: JSON.parse(localStorage.getItem("details")),
    };
  },
  validations: {
    body: {
      required,
    },
    rating: {
      required,
    },
    title:  {}
  },
  methods: {
    ...mapActions([
      "userReviewSessionPost",
      "getSessionReviewBatch",
      "userReviewSessionUpdate",
    ]),

    async handleUserReview() {
      //for edit of session review
      if (this.editReview) {
        this.$v.$touch();
        if (this.$v.$invalid) {
          console.log("invalid");
        } else {
          const data = {
            batch_id: this.data.id,
            session_id: this.data.session_id,
            // course_id: this.course_id, // in course case
            group_id: this.data.group_id,
            title: this.title && this.title.length ? this.title : "", // check
            body: this.body,
            rating: this.rating,
            id: this.review_id,
          };
          await this.userReviewSessionUpdate(data);
          await this.getSessionReviewBatch(this.$route.params.id);
          this.$emit("hidePostReview", false);
        }
      }
      //for new session review
      else {
        this.$v.$touch();
        if (this.$v.$invalid) {
          console.log("invalid");
        } else {
          const data = {
            // trainer_id: this.data.trainer_id,
            batch_id: this.data.id,
            session_id: this.data.session_id,
            // course_id: this.course_id, // in course case
            group_id: this.data.group_id,
            title: this.title && this.title.length ? this.title : "", // check
            body: this.body,
            rating: this.rating,
          };
          await this.userReviewSessionPost(data);
          await this.getSessionReviewBatch(this.$route.params.id);
          this.$emit("hidePostReview", false);
        }
      }
    },

    handleStarClick(val) {
      this.rating = val;
    },
    hideReviewPost() {
      this.rating = null;
      this.$refs.reviewPost.reset();
      this.callerComp && this.callerComp === 'sessionModal' ? this.$emit("hidePostReview", false) : ''
    },
  },
};
</script>